import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type ConsultationBookingDTO = {
    name: string;
    description: string;
    email: string;
    phone:string;
    consultantId: string;
    consultantDateId: string;
};
type ConsultationBookingResponse = {
    data: object;
} & ApiError;
export const BookConsultation = (
    data: ConsultationBookingDTO
): Promise<ConsultationBookingResponse> => {
    return axios.post("/consultant-booking/create", data);
};
